import { StatusIndicatorType } from "ui/atoms/avatar/statusIndicator/interfaces";

export enum SignStatusEnums {
  PENDING_SIGNATURE = "pending_signature",
  SIGNED = "signed",
}

export const SignedStatusMapping: Record<SignStatusEnums, StatusIndicatorType> =
  {
    [SignStatusEnums.SIGNED]: "active",
    [SignStatusEnums.PENDING_SIGNATURE]: "warning",
  };

export const StatusTitleMapping: Record<SignStatusEnums, string> = {
  [SignStatusEnums.PENDING_SIGNATURE]: "Pending Sign-Off",
  [SignStatusEnums.SIGNED]: "Signed-Off",
};
